import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { SConfirmation } from '@slg/web-customer-shared';
import appConfig from '@/appConfig';
import {
  useStore, useRouter, useRouteRef, useGlobalErrorDialog, useGtm,
} from '@/composables';


import type { NavigationGuardNext, Route } from 'vue-router';

const __default__ = {
  name: 'ConfirmationPage',
  beforeRouteEnter(to: Route, _from: Route, next: NavigationGuardNext) {
    const hasOrderIdProperty = Object.prototype.hasOwnProperty.call(to.params, 'orderId');
    if (hasOrderIdProperty) {
      next();
    } else {
      // redirect to home page
      next('');
    }
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRouteRef();
const { setGlobalError } = useGlobalErrorDialog();
const { trackGtmEvent } = useGtm();

const getFirstName = computed(() => store.getters['auth/getFirstName']);
const getDeparturePlace = computed(() => store.getters['booking/getDeparturePlace']);
const getArrivalPlace = computed(() => store.getters['booking/getArrivalPlace']);
const getOrderId = computed(() => route.value.params.orderId);
const getAppConfig = computed(() => appConfig);

function toMainPage() {
  router.push({ name: 'Booking' });
}

async function handleServerError(e: unknown) {
  await setGlobalError(e as any);
}

onMounted(() => {
  trackGtmEvent(
    'Confirmation page',
    'Page',
    'Loaded',
    'Confirmation page is loaded',
  );
});

onBeforeUnmount(() => {
  store.commit('booking/clearBookingState');
  store.commit('opsZone/clearOpsZone');
});

return { __sfc: true,store, router, route, setGlobalError, trackGtmEvent, getFirstName, getDeparturePlace, getArrivalPlace, getOrderId, getAppConfig, toMainPage, handleServerError, SConfirmation }
}

})